import Const from 'constants';

const StackItemInterface = {
    getId() {
        return this.id;
    },
    getType() {
        return this.type;
    },
    isTypeAtLeast() {
        return this.type === Const.STACKS_TYPE_AT_LEAST;
    },
    isTypeAtMost() {
        return this.type === Const.STACKS_TYPE_AT_MOST;
    },
    isTypeExactly() {
        return this.type === Const.STACKS_TYPE_EXACTLY;
    },
    getStackedPlayerIds() {
        return this.selectedPlayers;
    },
    getStackedPlayersQuantity() {
        return this.selectedPlayers.length;
    },
    getKeyPlayerId() {
        return this.keyPlayer;
    },
    isKeyPlayerCpt() {
        return 1 === Number(this.keyPlayerType);
    },
    getLimit() {
        return Number(this.numberPlayers);
    },
};

export default StackItemInterface;
